import "./assets/style/css/tailwind.css";
import "./assets/style/sass/main.scss";
import "./assets/style/sass/mixin.scss";
import VueApexCharts from "vue3-apexcharts";
import VCalendar from "v-calendar";
import "v-calendar/dist/style.css";
import { vMaska } from "maska";
import Vue3SimpleHtml2pdf from "vue3-simple-html2pdf";
export default {
  install(app) {
    app.use(VueApexCharts);
    app.use(VCalendar, {});
    app.directive("maska", vMaska);
    app.use(Vue3SimpleHtml2pdf);
  },
};
